export default __webpack_public_path__ + "9b01aec1fc3a3e5355c5e8c43fc42f77.jpg";